import { render, staticRenderFns } from "./EditNewMerit.html?vue&type=template&id=732a5168&external"
import script from "./EditNewMerit.ts?vue&type=script&lang=ts&external"
export * from "./EditNewMerit.ts?vue&type=script&lang=ts&external"
import style0 from "./EditNewMerit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports